import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f87dd18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative aspect-[4/3] bg-primary-100" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-16 h-16 text-primary-300",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5",
    d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "p-4" }
const _hoisted_7 = { class: "font-heading font-semibold text-primary-800 mb-1 line-clamp-1" }
const _hoisted_8 = { class: "text-sm text-primary-500 line-clamp-2 mb-3" }
const _hoisted_9 = { class: "flex items-center justify-between text-xs text-primary-400" }
const _hoisted_10 = { class: "flex items-center gap-2" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = {
  key: 1,
  class: "w-6 h-6 rounded-full bg-primary-200 flex items-center justify-center text-primary-500 text-xs font-medium"
}
const _hoisted_13 = {
  key: 0,
  class: "px-4 pb-4 pt-0 border-t border-primary-100"
}
const _hoisted_14 = { class: "text-sm text-primary-600 mt-3 whitespace-pre-wrap" }
const _hoisted_15 = { class: "mt-4 flex items-center justify-between" }
const _hoisted_16 = { class: "text-xs text-primary-400" }

import { computed, ref, PropType } from "vue";
import CommentLayout from "@/components/comments/CommentLayout.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  item: {
    type: Object as PropType<Post>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const expanded = ref(false);
const showComments = ref(false);

const badgeClass = computed(() => {
  return props.item.type === "free"
    ? "bg-emerald-500 text-white"
    : "bg-green-500 text-white";
});

const badgeText = computed(() => {
  return props.item.type === "free" ? "FREE" : "For Sale";
});

const authorName = computed(() => {
  return `${props.item.author.first_name} ${props.item.author.last_name}`;
});

const authorInitials = computed(() => {
  const first = props.item.author.first_name?.[0] || "";
  const last = props.item.author.last_name?.[0] || "";
  return (first + last).toUpperCase();
});

const friendlyDate = computed(() => {
  const today = new Date();
  const date = new Date(props.item.created_on);
  const delta = Math.round((today.getTime() - date.getTime()) / 1000);

  const minute = 60;
  const hour = minute * 60;
  const day = hour * 24;

  if (delta < 30) return "just now";
  if (delta < minute) return `${delta}s ago`;
  if (delta < 2 * minute) return "1m ago";
  if (delta < hour) return `${Math.floor(delta / minute)}m ago`;
  if (Math.floor(delta / hour) === 1) return "1h ago";
  if (delta < day) return `${Math.floor(delta / hour)}h ago`;
  if (delta < day * 2) return "yesterday";
  return `${Math.floor(delta / day)}d ago`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "bg-white rounded-xl border border-primary-200 shadow-soft overflow-hidden hover:shadow-card transition-shadow cursor-pointer",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (expanded.value = !expanded.value))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.item.image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.item.image,
            alt: __props.item.title,
            class: "w-full h-full object-cover"
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5)),
      _createElementVNode("span", {
        class: _normalizeClass(["absolute top-3 left-3 px-3 py-1 text-sm font-bold rounded-full shadow-sm", _unref(badgeClass)])
      }, _toDisplayString(_unref(badgeText)), 3)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h3", _hoisted_7, _toDisplayString(__props.item.title), 1),
      _createElementVNode("p", _hoisted_8, _toDisplayString(__props.item.description), 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (__props.item.author.profile)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: __props.item.author.profile,
                alt: _unref(authorName),
                class: "w-6 h-6 rounded-full object-cover"
              }, null, 8, _hoisted_11))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(authorInitials)), 1)),
          _createElementVNode("span", null, _toDisplayString(_unref(authorName)), 1)
        ]),
        _createElementVNode("span", null, _toDisplayString(_unref(friendlyDate)), 1)
      ])
    ]),
    (expanded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, _toDisplayString(__props.item.description), 1),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(__props.item.comments?.length || 0) + " responses ", 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showComments.value = !showComments.value), ["stop"])),
              class: "text-sm text-accent-600 hover:text-accent-700 font-medium"
            }, _toDisplayString(showComments.value ? "Hide" : "View") + " Comments ", 1)
          ]),
          (showComments.value)
            ? (_openBlock(), _createBlock(CommentLayout, {
                key: 0,
                post_id: __props.item.id,
                comments: __props.item.comments || [],
                class: "mt-4"
              }, null, 8, ["post_id", "comments"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})